import { Editor } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';

// text/plain with a marker prefix rather than a custom MIME - ProseMirror's default dragover handler recognizes text/plain and calls preventDefault so the drop cursor works without a custom handleDragOver.
const LITERATURE_DND_PREFIX = 'confideck-literature:';

export const encodeLiteratureDrag = (literatureId: string): string => `${LITERATURE_DND_PREFIX}${literatureId}`;

export const decodeLiteratureDrag = (data: string | undefined): string | null =>
  data?.startsWith(LITERATURE_DND_PREFIX) ? data.slice(LITERATURE_DND_PREFIX.length) : null;

const getLiteratureCitationDropPlugin = (editor: Editor) =>
  new Plugin({
    key: new PluginKey('literatureCitationDrop'),
    props: {
      handleDrop(view, event) {
        const literatureId = decodeLiteratureDrag(event.dataTransfer?.getData('text/plain'));
        if (!literatureId) return false;
        event.preventDefault();
        const coords = view.posAtCoords({ left: event.clientX, top: event.clientY });
        const insertPos = coords?.pos ?? view.state.selection.from;
        editor.chain().focus().setTextSelection(insertPos).insertLiteratureCitation(literatureId).run();
        return true;
      },
    },
  });

export default getLiteratureCitationDropPlugin;
